import { gql } from '@anyx/common-graphql';

export const PRODUCT_SET_VARIANTS_SELECTOR_TAGS = gql(/* GraphQL */ `
  query ProductSetVariantsSelectorTags($filter: ProductTagsFilterInput) {
    tagsV2(filter: $filter)
  }
`);
